module.exports = function() {
    return {
        run() {
            function getCities() {
                $('.cities-select').hide()
                axios.get('/async_loading/main/get_cities')
                    .then((data) => {
                        for (let city of data.data) {
                            $('.cities-select').append(`
                                <option value="${city.domain}">${city.value}, ${city.region}</option>
                            `);
                        }

                        $('.city-selection').popover('update');
                        $('.cities-select').selectize({
                            placeholder: 'Например, Санкт-Петербург'
                        });
                    });
            }

            // Popover выбора города
            $('.city-selection').popover({
                animation: false,
                html: true,
                sanitize: false,
                placement: 'bottom',
                trigger: 'click',
                container: 'header',
                content: $('#geolocation-popover').html()
            });
            $('#geolocation-popover').empty();

            // Если у пользователя нет сессии, предлагаем выбрать город
            if (!$('#old-user').data('old-user')) {
                if ($('#mobile-state').is(':hidden')) {
                    $('.pc.city-selection').popover('show');
                } else {
                    $('.mobile.city-selection').popover('show');
                }
            }

            // При скролле скрывать выбор города
            $(window).scroll(function() {
                if ((!$('#old-user').data('old-user')) && ($(window).scrollTop() > 400)) {
                    $('.pc.city-selection').popover('hide');
                }
            });

            // Изменение ширины экрана
            $(window).resize(function() {
                if ($('#mobile-state').is(':hidden')) {
                    $('.mobile.city-selection').popover('hide');
                } else {
                    $('.pc.city-selection').popover('hide');
                }
            });

            // Выбрать другой город в модальном окне
            $('body').on('click', '.step-1 .to-step-2', () => {
                getCities();
                $('.step-1').removeClass('d-flex').addClass('d-none');
                $('.step-2').addClass('d-flex');
                // $(this).closest('.geolocation').find('.fa-close').removeClass('d-none');
                // $('.city-selection').popover('update');
                // $('.cities-select').selectize({
                //     placeholder: 'Например, Санкт-Петербург'
                // });
            });

            // Если у пользователя есть сессия, то пропустим первый шаг и сразу предоставим выбор городов
            $('body').on('shown.bs.popover', () => {
                // getCities();
                if ($('#old-user').data('old-user')) {
                    $('.step-1 .to-step-2').click();
                    $('.step-1 .to-step-2').closest('.geolocation').find('.fa-close').removeClass('d-none');
                }
            });

            // Смена города по ссылкам в модальном окне
            $('body').on('click', '.city-modal-link', function(event) {
                event.preventDefault();
                $('#city-form').find('.city-selection-domain').val($(this).data('city'));
                $('#city-form').submit();
            });

            // Пользователь соглашается с предлагаемым городом
            $('body').on('click', '.user-city-accept ', function(event) {
                event.preventDefault();
                $('.city-selection').popover('hide');
                $('#old-user').data('old-user',1);

                axios.post('/set_city_session', {
                    city: $(this).closest('form').find('input[name="city"]').val()
                })
                .then(function(response) {
                    console.log(response.data);
                });
            });

            // Закрыть окно выбора городов
            $('body').on('click', '.geolocation .close', function() {
                $('.city-selection').popover('hide');
            });
        }
    }
}
